import React from 'react';
import Icon from '../../../components/AppIcon';

const MobileViewerControls = ({
  viewMode,
  onViewModeChange,
  isPlaying,
  onToggleAnimation,
  isExploded,
  onToggleExplode,
  explodeScale,
  onExplodeScaleChange,
  onShare,
  bottomClass = "bottom-0"
}) => {
  const controls = [
    { id: 'shaded', icon: 'Eye', onClick: () => onViewModeChange('shaded'), label: 'Shaded', isActive: viewMode === 'shaded' },
    { id: 'wireframe', icon: 'Grid3X3', onClick: () => onViewModeChange('wireframe'), label: 'Wireframe', isActive: viewMode === 'wireframe' },
    { 
      id: 'x-ray', 
      icon: 'Scan', 
      onClick: () => {
        if (viewMode === 'x-ray') {
          onViewModeChange('x-ray-gray');
        } else if (viewMode === 'x-ray-gray') {
          onViewModeChange('shaded');
        } else {
          onViewModeChange('x-ray');
        }
      }, 
      label: viewMode === 'x-ray' ? 'Z-Ray Col' : (viewMode === 'x-ray-gray' ? 'Z-Ray Gry' : 'Z-Ray'), 
      isActive: viewMode === 'x-ray' || viewMode === 'x-ray-gray' 
    },
    { id: 'explode', icon: 'Asterisk', onClick: onToggleExplode, label: 'Explode', isActive: isExploded },
    { id: 'animation', icon: isPlaying ? 'Pause' : 'Play', onClick: onToggleAnimation, label: 'Anim' },
    { id: 'share', icon: 'Share2', onClick: onShare, label: 'Share' }
  ];

  return (
    <div className={`fixed ${bottomClass} left-0 right-0 z-[40] w-full max-w-[100vw] bg-card/95 backdrop-blur-soft border-t border-border pb-[env(safe-area-inset-bottom,0px)]`}>
      {isExploded && (
        <div className="px-4 py-3 border-b border-border/50 bg-slate-800 text-white shadow-md animate-in slide-in-from-bottom-2">
          <div className="flex items-center gap-3">
            <Icon name="Asterisk" size={16} className="text-white shrink-0" />
            <input
              type="range"
              min="0"
              max="3"
              step="0.1"
              value={explodeScale || 0}
              onChange={(e) => onExplodeScaleChange(parseFloat(e.target.value))}
              className="flex-1 h-2 bg-slate-500 rounded-lg appearance-none cursor-pointer accent-primary [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:w-5 [&::-webkit-slider-thumb]:h-5 [&::-webkit-slider-thumb]:bg-primary [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:shadow-md [&::-moz-range-thumb]:w-5 [&::-moz-range-thumb]:h-5 [&::-moz-range-thumb]:bg-primary [&::-moz-range-thumb]:border-none [&::-moz-range-thumb]:rounded-full"
            />
          </div>
        </div>
      )}
      <div className="flex justify-between items-center px-2 py-2 w-full">
        {controls.map((ctrl) => (
          <button
            key={ctrl.id}
            onClick={ctrl.onClick}
            className={`flex flex-col items-center justify-center gap-1 p-1 sm:p-2 rounded-lg transition-colors flex-1 min-w-0 ${
              ctrl.isActive ? 'bg-primary text-primary-foreground' : 'text-muted-foreground hover:text-foreground'
            }`}
          >
            <Icon name={ctrl.icon} size={20} className="shrink-0" />
            <span className="text-[10px] font-medium truncate w-full text-center">{ctrl.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default MobileViewerControls;
